import { EventEmitter } from "events";
import dispatcher from "../dispatchers/dispatcher";

class DefaultAutoContainerStore extends EventEmitter {
    constructor() {
        super();
        this.initData();
    }
    initData() {
        this.urlObj = {};
        this.resData = "";
    }
    _setUrlObj(urlObj) {
        //set method to store url object.
        this.urlObj = urlObj;
    }

    _getUrlObj() {
        //get method to store url object.
        let isSSO = eval(localStorage.getItem("isSSO"));
        const localUrlObj = localStorage.getItem("urlObj");
        if (isSSO || localUrlObj?.includes("domain_name=")) {
            try {
                let urlObj = localStorage.getItem("urlObj")
                    ? JSON.parse(localStorage.getItem("urlObj"))
                    : {};
                return urlObj;
            } catch (e) {
                // eslint-disable-next-line no-console
                console.log(e);
                return this.urlObj;
            }
        } else {
            return this.urlObj;
        }
    }
    _setAutoRedirectContainerActionRes(response) {
        this.resData = response;
        this.emit("change", "AutoRedirectContainerActionRes");
    }

    _getAutoRedirectContainerActionRes() {
        return this.resData;
    }

    _handleFaildResponceAction(res_str) {
        this.resData = res_str;
        this.emit("change", "AutoRedirectContainerActionFaildRes");
    }

    _handleActions(action) {
        switch (action.type) {
            case "AutoRedirectContainerActionRes": {
                this._setAutoRedirectContainerActionRes(action.response);
                break;
            }
            case "AutoRedirectContainerActionFaildRes": {
                this._handleFaildResponceAction(action.res_str);
                break;
            }
            case "CLEAR_ALL": {
                this.initData();
                break;
            }
            default:
                return;
        }
    }
}

const defaultAutoContainerStore = new DefaultAutoContainerStore();
dispatcher.register(defaultAutoContainerStore._handleActions.bind(defaultAutoContainerStore));
export default defaultAutoContainerStore;
